import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-employee-sport-twenty-three',
  templateUrl: './employee-sport-twenty-three.component.html',
  styleUrls: ['./employee-sport-twenty-three.component.scss']
})
export class EmployeeSportTwentyThreeComponent implements OnInit {

  constructor() { 

  }

  ngOnInit(): void {
    if (!localStorage.getItem('foo')) { 
      localStorage.setItem('foo', 'no reload') 
      location.reload() 
    } else {
      localStorage.removeItem('foo') 
    }

  }
 
}
